export const fontFamily = {
    font: 'Inter, sans-serif',
    monoFont: 'Sono, monospace',
    serifFont: '"ivypresto-display", serif',
} as const;
